import React, { memo, useState } from "react";

const PrivacyPolicy = memo(() => {
  const [privacyModal, setPrivacyModal] = useState(false);
  return (
    <>
      <div className="privacy">
        <p>
          <button onClick={() => setPrivacyModal(true)}>
            個人情報の取り扱い
          </button>
          にご同意の上、
          <br className="sp" />
          確認画面へお進みください。
        </p>
      </div>
      <div className={privacyModal ? "privacy_modal isShow" : "privacy_modal"}>
        <span onClick={() => setPrivacyModal(false)}></span>
        <div>
          <b>個人情報の取り扱いに関して</b>
          <p>
            NOYESは、お客様よりお預かりした個人情報の取り扱いについて、下記の通りお約束いたします。
          </p>
          <ul>
            <li>
              1.個人情報の利用について
              <br />
              NOYESは、お客様よりご提示いただきました個人情報を、お客様へ通したサービス利用目的の達成に必要な範囲内で、利用いたします。
            </li>
            <li>
              2.個人情報の第三者提供について
              <br />
              NOYESは、個人情報保護法等の法令に定めのある場合を除き、個人情報をあらかじめご本人の同意を得ることなく、第三者に提供いたしません。
            </li>
            <li>
              3.個人情報の開示等について
              <br />
              個人情報の開示、変更、削除の求めがあった場合には、お客様ご本人であることをご確認させていただいたうえで、すみやかに対応いたします。
            </li>
            <li>以上</li>
          </ul>
          <button onClick={() => setPrivacyModal(false)}>閉じる</button>
        </div>
      </div>
    </>
  );
});

export default PrivacyPolicy;
